// extracted by mini-css-extract-plugin
module.exports = {"dataLabel":"styles_dataLabel__AciUA","value":"styles_value__iMXSI","loadingWrapper":"styles_loadingWrapper__bGugy"};